import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { CircleLoader } from 'components/loaders'
import styles from './section.styl'

class Section extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    contentLoader: PropTypes.node,
    loading: PropTypes.bool,
    fullWidth: PropTypes.bool,
    inModal: PropTypes.bool,
    inBox: PropTypes.bool,
    loadingDescription: PropTypes.string,
    loadingNote: PropTypes.string
  }
  static defaultProps = {
    loading: false,
    fullWidth: false,
    inModal: false,
    loadingDescription: '',
    loadingNote: '',
    contentLoader: null
  }

  render() {
    const {
      loading,
      children,
      fullWidth,
      inModal,
      loadingDescription,
      loadingNote,
      inBox,
      contentLoader
    } = this.props

    const navigatorId = (navigator && navigator.userAgent.toLowerCase()) || ''
    let isSafari = false

    if (navigatorId.includes('safari') && !navigatorId.includes('chrome')) {
      isSafari = true
    }

    return (
      <div
        className={cx({
          [styles.withNote]: loadingNote,
          [styles.loading]: loading,
          [styles.fullWidth]: fullWidth,
          [styles.inBox]: inBox,
          [styles.inModal]: inModal,
          [styles.withRender]: contentLoader
        })}
      >
        {loading
          ? <div
              className={cx(styles.loader, {
                [styles.withNote]: loadingNote
              })}
            >
              {(!contentLoader || isSafari) && <CircleLoader size={60} />}
              {Boolean(contentLoader && !isSafari) && contentLoader}
              {loadingDescription &&
                <span className={styles.loaderText}>
                  {loadingDescription}
                  {loadingNote
                    ? <p className={styles.loadingNote}>{loadingNote}</p>
                    : null}
                </span>}
            </div>
          : null}
        <div className={styles.content}>
          {children}
        </div>
      </div>
    )
  }
}

export default Section
